import HttpService from "@/utils/httpData"
export default {
    get() {        
        let apiEndpoint = `lesson/get-filter`;
        let params = {}
        return HttpService.get(apiEndpoint, params)
                .then(res => {
                    return res && res.data && !res.errors && res.data.data ? res.data.data : null;
                })
                .catch(e => {return false}
        );
    }
}